import React, { Component } from 'react';

class IconSidebarItemManager extends Component {
    render() {
        return (
            <svg
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x={0}
                y={0}
                viewBox="0 0 40 25"
                style={{
                    enableBackground: "new 0 0 40 25",
                }}
                xmlSpace="preserve"
            >
                <path
                    fill={this.props.isActive ? "#26A" : "#424242"}
                    className="st0"
                    d="M18 20.9c0-.5 0-1-.1-1.5-.6-2.9-2.3-5-5.1-6.1 2.4-1.6 3-4.6 2.3-6.7-.8-2.4-3.1-4.1-5.6-4.1-2.6 0-4.9 1.6-5.7 4.1-.8 2.1-.2 5 2.2 6.7-.2.1-.3.1-.5.2-3 1.4-4.6 3.8-4.8 7.1v3c0 .6.3.9.9.9H17c.6 0 .9-.3.9-.9v-.7c.1-.7.1-1.4.1-2zM5.4 6.7C6 5.3 7 4.5 8.5 4.2c1.5-.3 2.9.1 4 1.2-.3.3-.7.6-1.2.9-.8.4-1.6.6-2.6.7-1.2.1-2.3 0-3.3-.3zm8.9 12.8c-.3-.1-.7 0-.9.2-.1.2-.2.4-.2.6V23H5.6v-2.6c0-.4-.3-.8-.7-.8-.2 0-.4 0-.6.2-.2.2-.3.4-.3.6V23H2.2v-2.5c0-1.3.5-2.6 1.4-3.7.9-1.1 2-1.9 3.4-2.3.2.4.5.8.9 1-.4.7-.7 1.5-.8 2.7-.1.9-.2 1.8.1 2.6.3 1 .9 1.5 1.8 1.7 1 .2 1.9-.3 2.4-1.2.3-.6.5-1.3.4-2.1-.1-1.1-.3-2.1-.6-2.9-.1-.2-.2-.5-.3-.7v-.1c.3-.3.6-.6.8-1 .5.1 1 .3 1.5.6 1.9 1.1 3 2.7 3.2 4.7.1.5.1 1.1.1 1.6v1.5h-1.7v-2.7c0-.3-.2-.6-.5-.7zm-6.9-7.2C5.8 11.5 4.9 9.9 5 8.2c1.5.4 2.9.4 4.4.2 1.7-.3 3-.8 4-1.7.6 1.3.6 3.3-.8 4.7-1.3 1.4-3.5 1.8-5.2.9zm1.4 2h1.1c-.2.1-.4.2-.6.2-.1 0-.3 0-.5-.2zm1.5 5.5c0 .3-.1.6-.2.8-.1.3-.4.4-.7.4-.3 0-.5-.1-.7-.5-.2-.4-.2-.8-.2-1.1 0-1.1.2-2 .6-2.8.1-.2.2-.3.3-.5.2.3.4.6.5.9.3.9.5 1.9.4 2.8z"
                />
                <path
                    fill={this.props.isActive ? "#26A" : "#424242"}
                    className="st0"
                    d="M25 11.8c.3-.3.3-.6.2-1-.1-.3-.4-.6-.8-.6l-2-.3c-.2-.5-.5-1-.7-1.5l-.2-.3c-.2-.3-.5-.5-.8-.5-.4 0-.7.2-.8.5l-.4.8c-.2.3-.3.7-.5 1-.6.1-1.3.2-1.9.3-.2 0-.5.1-.7.3-.3.4-.3.9.1 1.2.5.5 1 .9 1.4 1.4-.1.3-.1.6-.2.9l-.2 1.2V15.5c.1.3.3.5.5.6.3.1.5.1.8 0l1.8-.9.6.3.6.3c.2.1.5.2.7.4.1.1.3.1.4.1.2 0 .4-.1.5-.2.3-.2.4-.5.3-.9-.1-.7-.2-1.3-.3-2 .6-.5 1.1-.9 1.6-1.4zm-6.1 2.6c.1-.4.1-.7.2-1.1 0-.3 0-.6-.3-.8l-1.3-1.2c.1 0 .2 0 .4-.1l.5-.1c.3 0 .6-.1.9-.1.3 0 .6-.2.7-.5l.6-1.2.2-.4c.1.3.3.6.4.8l.2.4c.1.1.1.2.2.3.2.3.4.5.8.5.3 0 .6.1.8.1l.9.1-.3.3-.9.9c-.3.3-.4.6-.3 1.1l.3 1.5v.1c-.5-.3-1-.5-1.5-.8-.3-.2-.6-.2-1 0s-.9.5-1.3.7l-.2.1v-.6z"
                />
            </svg>
        );
    }
}

export default IconSidebarItemManager;